import api from './index';

let exports = {};
//
// 分页查询
exports.getRetailStaffScorePageList = function (data, callback) {
    api.post('/retailer/score/staff/score/page/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};


export default exports;
/**
 * Created by rxsl-104 on 2019/12/5.
 */



//////////////////
// WEBPACK FOOTER
// ./src/api/retailStaffScore.js
// module id = 1742
// module chunks = 0